import { defineComponent } from "vue";
import { Checkbox as ElCheckbox, Radio as ElRadio } from "element-ui";
import { definePropType } from "@types-vue/props";
export default defineComponent({
    name: "PtCascaderNode",
    components: {
        ElCheckbox: ElCheckbox,
        ElRadio: ElRadio
    },
    props: {
        tooltip: String,
        type: {
            type: definePropType([
                String,
                undefined
            ]),
            default: undefined
        },
        // disabled: {
        //   type: Boolean,
        //   default: false,
        // },
        value: {
            type: Boolean
        },
        checked: {
            type: Boolean
        },
        label: {
            type: String
        },
        isLeaf: {
            type: Boolean
        },
        expended: {
            type: Boolean
        }
    },
    setup: function setup() {
        return {};
    }
});
